q<template>
  <b-row>
    <!--    Todo : Add settings for home, office and cars to be added the app wont be used wthout adding a car-->
    <b-col class="b-avatar-img mb-5 col-md-12 col-12">
      <div class="position-absolute tt-alert-block">
        <transition
          name="alert-slide-fade"
          leave-active-class="animate__animated animate__fadeOutUp"
        >
          <b-alert variant="success" size="lg" show="" v-if="perfectSave">
            Your new car was successfully added</b-alert
          >
        </transition>
        <transition
          name="alert-slide-fade"
          leave-active-class="animate__animated animate__fadeOutUp"
        >
          <b-alert variant="danger" size="lg" show="" v-if="failedSave">
            There was a problem deleting the place please try again.</b-alert
          >
        </transition>
      </div>
      <div>
        <div>
          <h1 class="text-center font-weight-500 mb-0 mt-3">Car</h1>
        </div>
      </div>
      <div class="mt-md-0 mb-5 tt-mt">
        <hr class="mb-4" />
        <new-car :editableCar="editableCar"></new-car>
      </div>
      <!--      <div class="mt-md-0 mb-5 tt-mt">-->
      <!--        <car @editableCar="setEditableCar"></car>-->
      <!--      </div>-->
    </b-col>
  </b-row>
</template>

<script>
import NewCar from "@/components/forms/NewCar";
// import Car from "./Car";
import { mapGetters } from "vuex";
export default {
  name: "Settings",
  components: {
    NewCar
    // Car
  },
  data() {
    return {
      editableCar: ""
    };
  },
  computed: {
    ...mapGetters({
      perfectSave: "getIsSucces",
      failedSave: "getIsError",
      date: "stat/getStartDate"
    })
  },

  methods: {
    setEditableCar: function(car) {
      this.editableCar = car;
    }
  }
};
</script>

<style scoped></style>
